var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showModal
    ? _c(
        "div",
        [
          _vm.button.PaddedModal
            ? _c(
                "w-modal",
                {
                  model: {
                    value: _vm.showModal,
                    callback: function ($$v) {
                      _vm.showModal = $$v
                    },
                    expression: "showModal",
                  },
                },
                [
                  _c(
                    "w-card",
                    { staticClass: "custom-button-modal-card padded" },
                    [
                      _c(
                        "w-card-title",
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.button.Title || _vm.button.Name) +
                              " "
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$t("common.close"),
                                  expression: "$t('common.close')",
                                },
                              ],
                              attrs: { white: "" },
                              on: { click: _vm.close },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "mts mr",
                                attrs: { icon: "times" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        { staticClass: "iframe-container" },
                        [
                          _c("iframe", {
                            ref: "frame",
                            staticClass: "iframe",
                            attrs: { src: _vm.computedUrl, frameborder: "0" },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-card",
                {
                  staticClass: "custom-button-modal-card fullscreen",
                  style: { height: "100vh" },
                },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(
                        " " + _vm._s(_vm.button.Title || _vm.button.Name) + " "
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$t("common.close"),
                              expression: "$t('common.close')",
                            },
                          ],
                          attrs: { white: "" },
                          on: { click: _vm.close },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "mts mr",
                            attrs: { icon: "times" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-card-content", { staticClass: "iframe-container" }, [
                    _c("iframe", {
                      ref: "frame",
                      staticClass: "iframe",
                      attrs: { src: _vm.computedUrl, frameborder: "0" },
                    }),
                  ]),
                ],
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }